import {
  LOAD_PRIVACY_WORDING,
  LOAD_PRIVACY_WORDING_SUCCESS,
  LOAD_PRIVACY_WORDING_ERROR,
  LOAD_TERM_WORDING,
  LOAD_TERM_WORDING_SUCCESS,
  LOAD_TERM_WORDING_ERROR,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';
import { initialState } from './initialize-state';

const loginReducer = handleActions(
  new Map([
    [
      LOAD_PRIVACY_WORDING,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            privacyLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_PRIVACY_WORDING_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loginLoading: { $set: false },
          },
          privacyData: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_PRIVACY_WORDING_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loginLoading: { $set: false },
          },
        });
      },
    ],
    [
      LOAD_TERM_WORDING,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            termLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_TERM_WORDING_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            termLoading: { $set: false },
          },
          termData: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_TERM_WORDING_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            termLoading: { $set: false },
          },
        });
      },
    ],
  ]),
  initialState,
);
export default loginReducer;
